import {useCallback, useSyncExternalStore} from 'react';
import type {Component} from 'grapesjs';
import {isEmptyTextComponent} from '@EmailMakerReact/lib/email-maker-component-query-library';

const EMPTY_TEXT_LIVE_UPDATE_EVENTS = 'component:update:components component:update:content';
// postermywall-text replaces the GrapesJS text view's events, so component:input never fires while typing
const CANVAS_INPUT_EVENT = 'input';

export function useIsEmptyTextComponent(component: Component): boolean {
  const subscribe = useCallback(
    (onChange: () => void): (() => void) => {
      const canvasElement = component.getEl();
      component.on(EMPTY_TEXT_LIVE_UPDATE_EVENTS, onChange);
      canvasElement?.addEventListener(CANVAS_INPUT_EVENT, onChange);
      return (): void => {
        component.off(EMPTY_TEXT_LIVE_UPDATE_EVENTS, onChange);
        canvasElement?.removeEventListener(CANVAS_INPUT_EVENT, onChange);
      };
    },
    [component]
  );

  const getSnapshot = useCallback((): boolean => isEmptyTextComponent(component), [component]);

  return useSyncExternalStore(subscribe, getSnapshot);
}
